import React, { useState, useEffect } from "react";
import CreatableSelect from "react-select/creatable";
import {
  serviceFetchCommonInvestigations,
  serviceFetchDoctorsCustomInvestigations,
  serviceAddCustomInvestigationForDoctor,
} from "../services/api";

const InvestigationsInput = ({
  investigations,
  setInvestigations,
  labTestSuggestions,
  doctorId,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);

  useEffect(() => {
    // Format the labTestSuggestions and set them as the options
    const formattedSuggestions = labTestSuggestions.map((suggestion) => ({
      value: suggestion.test_name,
      label: suggestion.test_name,
      description: suggestion.description,
    }));
    setOptions(formattedSuggestions);
    console.log("labetesttttt", labTestSuggestions);
  }, [labTestSuggestions]);

  useEffect(() => {
    const fetchInvestigations = async () => {
      try {
        const commonInvestigations = await serviceFetchCommonInvestigations();
        const customInvestigations =
          await serviceFetchDoctorsCustomInvestigations(doctorId);

        let commonInvestigationsData = [];
        let customInvestigationsData = [];

        if (commonInvestigations?.status) {
          commonInvestigationsData = commonInvestigations?.data || [];
        }
        if (customInvestigations?.status) {
          customInvestigationsData = customInvestigations?.data || [];
        }

        const formattedOptions = [
          ...commonInvestigationsData,
          ...customInvestigationsData,
        ].map((inv) => ({
          value: inv.investigation_id.toString(),
          label: inv.investigation_name,
        }));

        setOptions(formattedOptions);
      } catch (error) {
        console.error("Failed to fetch investigations:", error);
      }
    };

    fetchInvestigations();
  }, [doctorId]);

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
  };

  const handleChange = async (selectedOptions) => {
    setInvestigations(selectedOptions);

    const newInvestigations = selectedOptions.filter(
      (option) =>
        !options.find((existingOption) => existingOption.value === option.value)
    );

    for (const newInv of newInvestigations) {
      try {
        await serviceAddCustomInvestigationForDoctor(doctorId, {
          name: newInv.label,
        });
      } catch (error) {
        console.error(
          `Failed to save custom investigation "${newInv.label}":`,
          error
        );
      }
    }
  };

  const handleSuggestionClick = (suggestion) => {
    const selectedOption = {
      value: suggestion.test_name,
      label: suggestion.test_name,
    };

    // Check if the selected option already exists in the investigations state
    const isAlreadySelected = investigations.some(
      (inv) => inv.value === selectedOption.value
    );

    if (!isAlreadySelected) {
      handleChange([...investigations, selectedOption]);
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "0.375rem",
      padding: "0.5rem",
      border: "1px solid #d1d5db",
    }),
    // Add other custom styles if needed
  };

  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-800 mb-1">Lab Tests</h2>
      <hr className="mt-1 mb-4" />
      <CreatableSelect
        isMulti
        isClearable
        inputValue={inputValue}
        value={investigations}
        onInputChange={handleInputChange}
        onChange={handleChange}
        options={options}
        styles={customStyles}
        placeholder="Select or type to add investigations"
      />
      <div className="mt-4">
        <h3 className="text-md font-semibold text-gray-800 mb-2">
          Suggested Lab Tests
        </h3>
        <div className="flex flex-wrap space-x-2">
          {labTestSuggestions.map((suggestion, index) => (
            <button
              key={index}
              className="px-3 py-1 mb-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none"
              onClick={() => handleSuggestionClick(suggestion)}
              title={suggestion.description}
            >
              {suggestion.test_name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InvestigationsInput;
